export default "__VITE_ASSET__14b3424c__"